// extracted by css-extract-rspack-plugin
export default {"TabsList":"nPDvi","Tab":"r6sra","TabsPanel":"mqpTo","hideOverflow":"NIpmA","TabBody":"pzqTB","DatabasesTabBody":"FmwGs","ModelPersistenceConfigurationTabBody":"Ot61Q"};